import { AppShell, Button, Loader, Stack } from "@mantine/core";
import { AdminTabHeader } from "../shared/components/TabHeader";
import {
  displayInfoMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import { useRunDatabaseIntegrityChecksMutation } from "../slices/api/systemApi";

function UtilitiesTab() {
  const [runIntegrityChecks, { isLoading: isRunningIntegrityChecks }] =
    useRunDatabaseIntegrityChecksMutation();

  return (
    <AppShell.Main>
      <AdminTabHeader label="Utilities" />
      <Stack>
        <Button
          mt="md"
          disabled={isRunningIntegrityChecks}
          rightSection={isRunningIntegrityChecks ? <Loader size={14} /> : null}
          onClick={async () => {
            try {
              const result = await runIntegrityChecks({
                fixErrors: false,
              }).unwrap();
              if (result.errorsFound) {
                displayInfoMessage(result.errorMessage);
              } else {
                displayInfoMessage("No errors found during integrity checks.");
              }
            } catch (e) {
              displayServerErrorMessage(e);
            }
          }}
        >
          Run Database Integrity Checks
        </Button>
        <Button
          mt="md"
          disabled={isRunningIntegrityChecks}
          rightSection={isRunningIntegrityChecks ? <Loader size={14} /> : null}
          onClick={async () => {
            try {
              await runIntegrityChecks({ fixErrors: true }).unwrap();
            } catch (e) {
              displayServerErrorMessage(e);
            }
          }}
        >
          Fix Database Integrity Checks Where Possible
        </Button>
      </Stack>
    </AppShell.Main>
  );
}

export default UtilitiesTab;
